import React, { useEffect } from 'react'
import LoginForm from '../Components/LoginForm'
import { TfiMore } from 'react-icons/tfi'
import '../login.css'

const Page = () => {



  return (
    <div className='mobile-layout'>
      <div className='scroll-y'>
        <div className='bg-wrapper flex flex-col'>
          <div className='text-center py-5'>
            <div className='made-tag inline-block relative'>
              <small className='text-white absolute -top-2 uppercase text-[0.5rem] tracking-wider'>Made Digital By</small>
              <img className='inline-block' src='/hdfc-logo-new.png' width={120} />
              <img className='inline-block' src='/now-logo-new.png' width={60} />
            </div>
          </div>

          <LoginForm />

          <div className="login-bottom-nav grid grid-cols-4 gap-4"> {/**bg-gradient-to-b from-transparent to-black */}
            <div>
              <div className='nav-button-wrapper'>
                <div className='nav-button-icon-wrapper'>
                  <span className='nav-button-icon'>
                    <img src='/open-account.svg' className='inline-block' width={20} height={20} alt='open-account' />
                  </span>
                </div>
                <div className='nav-button-text'>
                  <small>Open Account</small>
                </div>
              </div>
            </div>
            <div>
              <div className='nav-button-wrapper'>
                <div className='nav-button-icon-wrapper'>
                  <span className='nav-button-icon'>
                    <img src='/payzapp.png' className='inline-block' width={20} height={20} alt='payzapp' />
                  </span>
                </div>
                <div className='nav-button-text'>
                  <small>PayZapp</small>
                </div>
              </div>
            </div>
            <div>
              <div className='nav-button-wrapper'>
                <div className='nav-button-icon-wrapper'>
                  <span className='nav-button-icon'>
                    <img src='/home-loan.svg' className='inline-block' width={20} height={20} alt='home-loan' />
                  </span>
                </div>
                <div className='nav-button-text'>
                  <small>Home Loan</small>
                </div>
              </div>
            </div>
            <div>
              <div className='nav-button-wrapper'>
                <div className='nav-button-icon-wrapper'>
                  <span className='nav-button-icon'>
                    <TfiMore size={20} color='#333333' className='inline' />
                  </span>
                </div>
                <div className='nav-button-text'>
                  <small>More</small>
                </div>
              </div>
            </div>
          </div>
         
        </div>
      </div>
    </div>
  )
}

export default Page